import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { Shield, X, Loader2 } from "lucide-react";

export default function ImpersonationBanner() {
    const { user } = useAuth();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    if (!user?.is_impersonating) return null;

    const stop = async () => {
        if (busy) return;
        setBusy(true);
        setError(null);
        try {
            // Stop impersonation
            await api.post("/admin/impersonate/stop");
            // Verify the session is really clean by re-fetching auth/me
            const me = await api.get("/auth/me");
            if (me.data?.user?.is_impersonating) {
                throw new Error("La sessione è ancora in impersonazione");
            }
            // Hard reload to /admin so all components pick up the admin context
            window.location.replace("/admin");
        } catch (e) {
            setError(e?.response?.data?.detail || e.message || "Errore durante l'uscita");
            setBusy(false);
        }
    };

    return (
        <>
            <button
                data-testid="impersonation-stop"
                onClick={stop}
                disabled={busy}
                title={`Stai vedendo come ${user.name} (${user.email}) — clicca per tornare admin`}
                className="fixed bottom-6 left-6 z-[60] group bg-ink-950 border border-amber-500/60 hover:border-amber-400 text-amber-300 hover:text-amber-200 px-3 py-2 text-xs font-medium flex items-center gap-2 shadow-lg backdrop-blur-md transition-all"
            >
                {busy ? <Loader2 size={13} className="animate-spin text-amber-400" /> : <Shield size={13} className="text-amber-400" />}
                <span className="max-w-[140px] truncate">{user.name}</span>
                {!busy && <X size={13} className="opacity-60 group-hover:opacity-100" />}
            </button>
            {error && (
                <div className="fixed bottom-20 left-6 z-[60] bg-red-950 border border-red-700 text-red-200 px-3 py-2 text-xs max-w-xs">
                    {error}
                </div>
            )}
        </>
    );
}
